// extracted by mini-css-extract-plugin
module.exports = {"dashStyle":"ChildTab_dashStyle__1Sw_a"};